
import { mapState } from 'vuex'
export default {
  components: {},
  props: {
    store: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('storeLocator', ['selectedStore']),
    shortAddress() {
      const { line1, town, postcode } = this.store.contact?.address
      return [line1, town, postcode].filter((val) => val).join(', ')
    },
    storeIsSelected() {
      return this.store === this.selectedStore
    },
  },
  watch: {
    selectedStore() {
      if (this.storeIsSelected) {
        this.$store.commit('storeLocator/SET_RESULTS_OFFSET_TOP', this.$el.offsetTop)
      }
    },
  },
  methods: {
    storeSelected() {
      this.$store.commit('storeLocator/SET_SELECTED_STORE', this.store)
    },
  },
}
